import {
    SCORE_BOOM_CARD,
    SCORE_BOOM_TARGET_CARD,
} from '../../../Constants/Score';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { CardStatus } from '../../../Prototype/Level/Card/CardStatus';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { IGameState } from '../../Game/IGameState';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseCardBehavior from './BaseCardBehavior';

export default class BoomCardBehavior extends BaseCardBehavior {
    public play(state: IGameState) {
        const cardStatus = CardStateHelper.getCardStatus(state, this.cardID);

        const targets: string[] = [];

        if (cardStatus === CardStatus.IN_PLAY) {
            const boomCardData = state.levelState.cardsState.cards[this.cardID];

            // Find all removable cards in play.
            // Regular, rising/lowering, fog, ice, bomb or water (value).
            const removableCardIDs = state.levelState.cardsState.inPlay.filter(
                cardID =>
                    state.levelState.cardsState.cards[cardID].type ===
                    CardType.value
            );

            removableCardIDs.forEach((cardID: string) => {
                if (cardID === this.cardID) return; // Skip this card.

                const cardData = state.levelState.cardsState.cards[cardID];
                const dx = Math.abs(boomCardData.x - cardData.x);
                const dy = Math.abs(boomCardData.y - cardData.y);
                if (dx < 300 && dy < 360) {
                    if (
                        !CardStateHelper.getCardBehavior(
                            state,
                            cardID
                        ).isBlocked(state, [CardModifierType.fog])
                    ) {
                        state = CardStateHelper.setCardDiscarded(state, cardID);

                        // Collect affected card IDs for task data.
                        targets.push(cardID);
                    }
                }
            });
        }

        // Discard self.
        state = CardStateHelper.setCardDiscarded(state, this.cardID);

        // Add score.
        const scores: number[] = [
            SCORE_BOOM_CARD,
            ...Array(targets.length).fill(SCORE_BOOM_TARGET_CARD),
        ];
        state = CardStateHelper.addTurnScore(state, ...scores);

        // Trigger explosion task.
        state = CardStateHelper.setStateTaskData(state, {
            task: CardTask.BOOM,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        // Update all cards behavior after some of them are discarded.
        state = CardStateHelper.updateCards(state);

        // Clear the undo history when a boom card is played.
        state = CardStateHelper.clearUndoHistory(state);

        return state;
    }
}
